document.addEventListener('DOMContentLoaded', function() {
  if (window.innerWidth < 1000) {
      var swiperContainers = document.querySelectorAll('.swiper-container');
      
      swiperContainers.forEach(function(container, index) {
  
          var swiper = new Swiper(container, {
              pagination: {
                  el: '.swiper-pagination',
                  clickable: true,
              },
              navigation: {
                  nextEl: ".swiper-button-next",
                  prevEl: ".swiper-button-prev",
              },
              grabCursor: true,
              slidesPerView: 1,
              spaceBetween: 0,
              autoplay: index === 0 ? { 
                  delay: 5000,
                  disableOnInteraction: false,
              } : false, 
              speed: 300,
              on: {
                  init: function () {
                      var swiperInstance = this;
                      
                     
                      if (index === 0) {
                          swiperInstance.params.speed = 6000; 
                          swiperInstance.autoplay.stop();

                          setTimeout(function() {
                              swiperInstance.slideTo(1);

                              setTimeout(function() {
                                  swiperInstance.slideTo(0);
                                  swiperInstance.autoplay.stop();

                                 
                                  swiperInstance.params.speed = 300;
                              }, 700);
                          }, 1000);
                      }
                  }
              }
          });
      });
  }
});